import dot from 'dot-object'

import type { IConversation } from '~/entities/container/conversation/interfaces/conversation'

import type { SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'
import type { IFedSearchResponse } from '~/features-shared/member/interfaces/search'

import type { SwymResponse } from '~/interfaces/services-dto'

export interface IConvFedSearch {
  /** conversation SUBJECT_URI */
  convUri: SUBJECT_6W_URI
  /** label/title of the conversation */
  label: string
  /** type of conversation */
  type: string
}

const MOVE_PROPS = [
  ['subject6wuri', 'subject_uri'],
  ['uri', 'subject_uri'],
]

export function conversationParser(response: SwymResponse<Record<string, string>>): SwymResponse<IConversation> {
  MOVE_PROPS.forEach(([from, to]) => {
    dot.move(from, to, response.result)
  })

  return response as unknown as SwymResponse<IConversation>
}
/**
 * Parser for fedsearch response of conversation search in the left column
 * @param responses
 * @returns returns conversation's title, subjectUri & type
 */
export function conversationSearchParser(responses: IFedSearchResponse) {
  const searchResults: IConvFedSearch[] = []

  if (responses.results) {
    responses.results.forEach((result) => {
      const parsedInfo: IConvFedSearch = {
        convUri: '',
        type: '',
        label: '',
      }
      result.attributes.forEach((attribute) => {
        switch (attribute.name) {
          case 'resourceid' :
            parsedInfo.convUri = attribute.value
            break
          case 'ds6w:what/ds6w:type' :
            parsedInfo.type = attribute.value
            break
          case 'ds6w:label' :
            parsedInfo.label = attribute.value
            break
        }
      })
      searchResults.push(parsedInfo)
    })
  }
  return searchResults
}
